<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- Bookmarks Container -->
      <bookmarks />
      <!-- <download-manager /> -->
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
      <search-bar />
      <bulletin
        v-if="$can('read', 'Boletines')"
        class="d-none d-lg-block"
      />
      <dashboard
        v-if="$can('read', 'Tableros')"
        class="d-none d-lg-block"
      />
      <notification />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue'
// import DownloadManager from '@/components/DownloadManager.vue'
import Bookmarks from './components/Bookmarks.vue'
import Locale from './components/Locale.vue'
import SearchBar from './components/SearchBar.vue'
import Bulletin from './components/Bulletin.vue'
import Dashboard from './components/Dashboard.vue'
import Notification from './components/Notification.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    Bookmarks,
    Locale,
    SearchBar,
    Bulletin,
    Dashboard,
    Notification,
    UserDropdown,
    // DownloadManager,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
